export const URL_FETCH_CONFIG = '/rest/zt/collector/{bizKey}/load';
export const URL_SUBMIT_PAGE = '/rest/zt/collector/{bizKey}/submit';
export const URL_SUBMIT_ADDITION = '/rest/zt/collector/{bizKey}/addition';
export const URL_INFORMATION_STATUS = '/rest/zt/collector/{bizKey}/status';
export const URL_INFORMATION_FINISH = '/rest/zt/collector/{bizKey}/finish';
export const URL_SMS_LOGIN = '/rest/zt/collector/{bizKey}/verify/login';
export const URL_SEND_SMS = '/rest/zt/collector/{bizKey}/verify/send';
export const URL_LOGIN_RENEWAL = '/rest/zt/collector/{bizKey}/verify/login-renewal'; // 短信续期接口，15min无须重复短信验真
export const URL_FORM_NOTICE = '/rest/zt/collector/{bizKey}/form-notice/load'; // 表单型公告接口
export const URL_DRAFT_SAVE = '/rest/zt/collector/{bizKey}/draft/save'; // 保存草稿接口（data 为 null 时执行删除语义）
export const URL_DRAFT_GET = '/rest/zt/collector/{bizKey}/draft/get'; // 查询草稿接口
export const ROUTER_NAME_BIZ = 'biz';
export const ROUTER_NAME_PAGE = 'page';
export const ROUTER_NAME_LANDING = 'landing';
export const ROUTER_NAME_CHECK = 'check';

export const PAGE_STATUS_MAP = {
    INVALID: 0, // 未填写
    PENDING: 1, // 待处理
    PROCESSED: 2, // 已处理
    REJECTED: 3, // 已驳回
    PROCESSING: 4, // 处理中
    FINISHED: 5, // 已归档
    UPLOADED: 6, // 上传成功
    EXPIRED: 7, // 已过期
};
